module.exports = __webpack_public_path__ + "static/media/angel.964a9305.png";